<template>
<div class="chapter">
<div class="inner_page">
<h2 class="fmh"><a id="page_iii"></a>Acknowledgements</h2>
<p class="noindent">I am grateful to Graham Greene who, in 1989, at the Oxford &amp; Cambridge Club, told us the anecdote on which I based the Rain Queen story;</p>
<p class="indent">And to Harould Courlander’s collection of oral African tales, <em class="italic">The Crest and the Hide</em>, for reminding me of a story from my childhood;</p>
<p class="indent">And to Rosemary Clunie.</p>
<a id="page_iv"></a>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 002_Ack.vue?27e79792